import {
    initialTrainingsContext,
    TrainingsContext,
} from "@/Contexts/TrainingsContext";
import { PageProps } from "@/types/page";
import { Training } from "@/types/training";
import { usePage } from "@/utils/turboSafeInertia";
import axios from "axios";
import { PropsWithChildren, useEffect, useMemo, useState } from "react";

export function TrainingsProvider({ children }: PropsWithChildren) {
    const { user, twoFactorPassed } = usePage<PageProps>().props;
    const [trainings, setTrainings] = useState(
        initialTrainingsContext.trainings,
    );
    const [isTrainingsInitialized, setIsTrainingsInitialized] = useState(false);

    const incompleteTrainingsCount = trainings.filter(
        (training) => !training.completed,
    ).length;

    const trainingsByCategory = useMemo(() => {
        const trainingsByCategoryUnsorted = trainings.reduce(
            (acc, training) => {
                if (!acc[training.category]) {
                    acc[training.category] = [];
                }
                acc[training.category].push(training);
                return acc;
            },
            {} as Record<string, Training[]>,
        );
        Object.values(trainingsByCategoryUnsorted).forEach((category) => {
            category.sort((a, b) => a.position - b.position);
        });
        return trainingsByCategoryUnsorted;
    }, [trainings]);

    const markAsCompleted = (training: Training) => {
        axios.post(route("trainings.complete", { training: training.id }));
        setTrainings(
            trainings.map((g) =>
                g.id === training.id ? { ...training, completed: true } : g,
            ),
        );
    };

    const loadTrainings = () => {
        axios.get(route("trainings.index")).then((response) => {
            setTrainings(response.data);
            setIsTrainingsInitialized(true);
        });
    };

    useEffect(() => {
        if (user?.type !== "coach" || !twoFactorPassed) return;
        loadTrainings();
    }, [user?.type, user?.id, twoFactorPassed]);

    return (
        <TrainingsContext.Provider
            value={{
                isTrainingsInitialized,
                trainings,
                setTrainings,
                trainingsByCategory,
                markAsCompleted,
                incompleteTrainingsCount,
            }}
        >
            {children}
        </TrainingsContext.Provider>
    );
}
